<template>
  <div>
    <Intro v-if="content.data.intro.visible" />
    <About v-if="content.data.about.visible" />
    <BeeHeroPack v-if="content.data.hero_pack.visible" />
    <Teaser v-if="content.data.teasers.visible" />
  </div>
</template>

<script>
import Intro from "./Intro.vue";
import About from "./About.vue";
import BeeHeroPack from "./BeeHeroPack.vue";
import Teaser from "./Teaser.vue";

export default {
  name: "MainPage",
  inject: ["content"],
  data() {
    return {
      title: "home page",
      windowWidth: 0,
    };
  },
  components: {
    Intro,
    About,
    BeeHeroPack,
    Teaser,
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  watch: {
    windowWidth: function () {
      if (this.windowWidth < 992) {
        this.$root.$emit("showAdditionalNavFn", true);
      }
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
};
</script>
